import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
	selector: '[CopyTextNew]',
	standalone: true
})

export class CopyTextDirectiveNew implements OnInit, AfterViewInit {
	@Input() type: 'tooltip' | 'badge' | 'changeIcon' = 'tooltip';
	@Input() text: string;


	private originalText: string;
	private iconElement: HTMLElement;
	constructor(
		private el: ElementRef,
		private renderer: Renderer2,
		private translate: TranslateService,
	) { }

	private getTranslation(key: string, name?: string, value?: number): string {
		let text = '';
		this.translate.get(key, { name, value }).subscribe((translatedText: string) => {
			text = translatedText;
		});
		return text;
	}

	ngAfterViewInit() {
		this.originalText = this.el.nativeElement.innerText.trim();
	}

	ngOnInit(): void {
		if (this.type === 'tooltip') {
			this.makeTooltipElement();
		}

		if (this.type === 'badge' || this.type === 'changeIcon') {
			this.findIconElement();
		}
	}

	makeTooltipElement(): void {
		const tooltip = this.renderer.createElement('span');
		this.renderer.setAttribute(tooltip, 'class', 'tooltip copy');
		this.renderer.appendChild(this.el.nativeElement, tooltip);

	}

	findIconElement(): void {
		this.iconElement = this.el.nativeElement.querySelector('i');
	}

	copyText(text: string) {
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = text;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}

	@HostListener('click') onMouseLeave() {
		this.copyText(this.text);
		this.renderer.addClass(this.el.nativeElement, 'copied');
		switch (this.type) {
			case 'tooltip':
				this.el.nativeElement.classList.add('show-copy-text');
				setTimeout(() => {
					this.el.nativeElement.classList.remove('show-copy-text');
				}, 1300);
				break;

			case 'badge':
				const originalIconClass = this.iconElement
					? Array.from(this.iconElement.classList).find(cls => cls.startsWith('ico-'))
					: null;

				// Change text to "Copy"
				this.renderer.addClass(this.el.nativeElement, 'copied-badge');
				this.el.nativeElement.childNodes.forEach((node: any) => {
					if (node.nodeType === Node.TEXT_NODE) {
						node.textContent = this.getTranslation('MG_GENERAL.COPY');
					}
				});

				// Check icon
				const successIconClass = 'ico-check-circle';
				if (this.iconElement) {
					if (originalIconClass) {
						this.renderer.removeClass(this.iconElement, originalIconClass);
					}
					this.renderer.addClass(this.iconElement, successIconClass);
				}

				setTimeout(() => {
					// Restore text
					this.el.nativeElement.childNodes.forEach((node: any) => {
						if (node.nodeType === Node.TEXT_NODE) {
							node.textContent = this.originalText;
						}
					});

					// Restore icon
					if (this.iconElement) {
						this.renderer.removeClass(this.iconElement, successIconClass);
						if (originalIconClass) {
							this.renderer.addClass(this.iconElement, originalIconClass);
						}
					}

					this.renderer.removeClass(this.el.nativeElement, 'copied-badge');
				}, 1300);
				break;

			case 'changeIcon':
				if (this.iconElement) {
					const originalIconClass = Array.from(this.iconElement.classList).find(cls =>
						cls.startsWith('ico-')
					);

					if (originalIconClass) {
						this.renderer.removeClass(this.iconElement, originalIconClass);
					}

					const successIconClass = 'ico-check-circle';

					this.renderer.addClass(this.iconElement, successIconClass);

					setTimeout(() => {
						this.renderer.removeClass(this.iconElement, successIconClass);
						if (originalIconClass) {
							this.renderer.addClass(this.iconElement, originalIconClass);
						}
					}, 1300);
				}
				break;
		}
		setTimeout(() => {
			this.renderer.removeClass(this.el.nativeElement, 'copied');
		}, 1300);
	}
}
